import React, { forwardRef } from 'react';
import { cn } from '@/utils/mergeClassName';
import * as RadixAccordion from '@radix-ui/react-accordion';

type AccordionRootProps = React.ComponentPropsWithoutRef<typeof RadixAccordion.Root>;

/**
 * **Accordion** basic anatomy
 * @example
 * ```
 *  import * as Accordion from '@/components/ui/Accordion';
 *
 *  <Accordion.Root>
 *    <Accordion.Item>
 *      <Accordion.Trigger>...</Accordion.Trigger>
 *      <Accordion.Content>...</Accordion.Content>
 *    </Accordion.Item>
 *  </Accordion.Root>
 * ```
 */

const AccordionRoot = forwardRef<React.ElementRef<typeof RadixAccordion.Root>, AccordionRootProps>(
  ({ children, className, ...rest }, ref) => (
    <RadixAccordion.Root ref={ref} className={cn('w-full', className)} {...rest}>
      {children}
    </RadixAccordion.Root>
  )
);

const Root = AccordionRoot;

export { type AccordionRootProps, AccordionRoot, Root };
